import { render, staticRenderFns } from "./RELConsumoApiExterna.vue?vue&type=template&id=1693a09a&"
import script from "./RELConsumoApiExterna.vue?vue&type=script&lang=js&"
export * from "./RELConsumoApiExterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports